import React from 'react';
import * as Routes from 'constants/routes';
import {useSelector} from 'react-redux';
import {NavLink} from 'react-router-dom';
import AnalyticsManager from '../../../../app/analytics';
import {combineClassNames, getDateFromUnix, getMediaPath} from 'app/functions';
import './index.scss';

const ArticleTile = ({article, className, analyticsSource}) => {
    const magazineCategories = useSelector((store) => store.data.magazineCategories);

    const category = (magazineCategories.filter(
            (item) => item.id === article.related_category)
    )[0];

    const handleClick = () => AnalyticsManager.logArticlePress(article?.id, article?.header_name, analyticsSource);

    if (category) {
        const toLink = `${Routes.magazine}/${category.title}/${article.id}`;

        return (
            <NavLink
                to={toLink}
                onClick={handleClick}
                className={combineClassNames('article-preview-wrapper', className)}
            >
                <div className="article-img-wrapper">
                    <img
                        src={getMediaPath(article.thumbnail_img_id)}
                        alt={article.thumbnail_alt}
                        className="article-img"
                    />
                </div>
                <div className="article-preview-footer">
                    <div className="article-headline">
                        {article.header_name}
                    </div>

                    {article.header_sub_name && (
                        <div className="article-details">
                            {article.header_sub_name}
                        </div>
                    )}

                    <div className="article-details">
                        {article.author && article.author + ' | '}
                        {getDateFromUnix(article.article_date)}
                    </div>
                </div>


            </NavLink>
        );
    } else {
        return null;
    }
};

export default ArticleTile;
